import Home from "./home/Home";
import About from "./about/About";
import Portfolio from "./portfolio/Portfolio";
import React from "react";
import { Box, Divider } from "@mui/material";

export default function SinglePageRoutes({ refs }) {
    return (
        <Box mt={"1rem"}>
            <Home innerRef={refs.refHome} />
            <Divider sx={{ my: 4 }} />
            <About innerRef={refs.refAbout} />
            <Divider sx={{ my: 4 }} />
            <Portfolio innerRef={refs.refPortfolio} />
        </Box>
    );
}
